import React from "react";
import { Link } from "react-router-dom";

// Module data — 22 business modules
const MODULES = [
  { slug: "link", icon: "fas fa-phone-volume", name: "LINK - Business Phone", ai: "LINK", tagline: "WebRTC Softphone, IVR, Voicemail & Call Analytics" },
  { slug: "chorus", icon: "fas fa-share-alt", name: "CHORUS - Social Media Studio", ai: "CHORUS", tagline: "Post, Schedule, Ads, Messenger, WhatsApp & AI Agents" },
  { slug: "google-workspace", icon: "fab fa-google", name: "Google Workspace", ai: "ECHO", tagline: "Gmail, Calendar, Drive, Docs, Sheets & Classroom" },
  { slug: "google-marketing", icon: "fas fa-bullhorn", name: "Google Marketing", ai: "CHORUS", tagline: "Google Ads, Analytics 4, YouTube & Business Profile" },
  { slug: "connect", icon: "fas fa-comments", name: "CONNECT - Team Chat & Video", ai: "ECHO", tagline: "Channels, Huddles, Meetings & File Sharing" },
  { slug: "accounting", icon: "fas fa-calculator", name: "Accounting & Finance", ai: "LEDGER", tagline: "GST, TDS, Bank Reconciliation & Financial Reports" },
  { slug: "hr", icon: "fas fa-users", name: "HR & Workforce", ai: "KEEPER", tagline: "Recruitment to Retirement — Payroll, Leave & Performance" },
  { slug: "inventory", icon: "fas fa-boxes", name: "Inventory Management", ai: "HAUL", tagline: "Multi-Warehouse, PO, GRN & Material Tracking" },
  { slug: "costing", icon: "fas fa-coins", name: "AI Costing Engine", ai: "FORGE", tagline: "Text, Image & Template-Based Estimation" },
  { slug: "crm", icon: "fas fa-handshake", name: "CRM & Sales Pipeline", ai: "BARTER", tagline: "Leads, Opportunities, Pipeline & Commission Tracking" },
  { slug: "projects", icon: "fas fa-project-diagram", name: "Project Management", ai: "FORGE", tagline: "Tasks, Boards, Milestones & Time Tracking" },
  { slug: "email", icon: "fas fa-envelope", name: "Email Suite", ai: "ECHO", tagline: "AI Compose, Multi-Mailbox & Custom Domain" },
  { slug: "compliance", icon: "fas fa-shield-alt", name: "GST & Tax Compliance", ai: "CIPHER", tagline: "GSTR-1/2/3B, TDS Returns & ITC Reconciliation" },
  { slug: "analytics", icon: "fas fa-chart-line", name: "Analytics & Reporting", ai: "VARN", tagline: "Dashboards, Custom Reports & Forecasting" },
  { slug: "storefront", icon: "fas fa-globe", name: "Website Builder", ai: "FORGE", tagline: "Drag-and-Drop Storefront with Custom Domains" },
  { slug: "quotations", icon: "fas fa-file-invoice", name: "Quotations & Proposals", ai: "BARTER", tagline: "Quote → E-Sign → Invoice in One Flow" },
  { slug: "customer-portal", icon: "fas fa-user-circle", name: "Customer Portal", ai: "ECHO", tagline: "Self-Service Booking, Payments & Tracking" },
  { slug: "remedy", icon: "fas fa-heartbeat", name: "REMEDY - Complaints", ai: "REMEDY", tagline: "SLA Monitoring, Escalation & Resolution Tracking", badge: "Free for All" },
  { slug: "seal", icon: "fas fa-stamp", name: "SEAL - E-Signature", ai: "SEAL", tagline: "Multi-Party Signing with Legal Audit Trail", badge: "Free for All" },
  { slug: "tender", icon: "fas fa-file-contract", name: "Tender Management", ai: "PROBE", tagline: "NIT Extraction, CPWD Rates & BOQ Bidding", badge: "Addon" },
  { slug: "upi-payments", icon: "fas fa-qrcode", name: "UPI Payment Collection", ai: "LEDGER", tagline: "Zero Gateway Fees with BharatQR", badge: "Free for All" },
  { slug: "barter", icon: "fas fa-store", name: "Barter Marketplace", ai: "BARTER", tagline: "Multi-Shop P2P Exchange & Referral System" },
];

const gridStyles = `
  .modules-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-bottom: 40px;
  }
  @media (max-width: 1199px) {
    .modules-grid { grid-template-columns: repeat(3, 1fr); }
  }
  @media (max-width: 991px) {
    .modules-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 575px) {
    .modules-grid { grid-template-columns: 1fr; }
  }
  .modules-grid-card {
    background: rgba(15, 20, 40, 0.6);
    border: 1px solid rgba(0,255,151,0.2);
    border-radius: 16px;
    padding: 24px;
    transition: all 0.3s ease;
    position: relative;
    text-decoration: none;
    color: inherit;
    display: block;
  }
  .modules-grid-card:hover {
    border-color: var(--color-primary);
    transform: translateY(-4px);
    box-shadow: 0 10px 40px rgba(0,255,151,0.1);
    color: inherit;
    text-decoration: none;
  }
  .modules-grid-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, rgba(0,255,151,0.15), rgba(0,255,151,0.05));
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    font-size: 22px;
    color: var(--color-primary);
  }
  .modules-grid-name {
    font-size: 1.05rem;
    font-weight: 600;
    margin-bottom: 4px;
    color: var(--color-white);
  }
  .modules-grid-ai {
    font-size: 0.75rem;
    color: rgba(255,255,255,0.45);
    margin-bottom: 10px;
  }
  .modules-grid-tagline {
    font-size: 0.85rem;
    color: rgba(255,255,255,0.65);
    line-height: 1.5;
    margin-bottom: 0;
  }
  .modules-grid-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 9px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .modules-grid-badge--free {
    background: linear-gradient(135deg, var(--color-primary), #00cc79);
    color: var(--color-secondary);
  }
  .modules-grid-badge--addon {
    background: linear-gradient(135deg, #8b5cf6, #6d28d9);
    color: white;
  }
`;

interface ModulesGridProps {
  limit?: number;
  showViewAll?: boolean;
}

const ModulesGrid: React.FC<ModulesGridProps> = ({ limit, showViewAll }) => {
  const modulesToShow = limit ? MODULES.slice(0, limit) : MODULES;

  return (
    <>
      <style>{gridStyles}</style>
      <div className="modules-grid">
        {modulesToShow.map((mod) => (
          <Link to={`/feature/${mod.slug}`} className="modules-grid-card" key={mod.slug}>
            {mod.badge && (
              <span className={`modules-grid-badge ${mod.badge === "Addon" ? "modules-grid-badge--addon" : "modules-grid-badge--free"}`}>
                {mod.badge}
              </span>
            )}
            <div className="modules-grid-icon">
              <i className={mod.icon}></i>
            </div>
            <h4 className="modules-grid-name">{mod.name}</h4>
            <span className="modules-grid-ai">Powered by {mod.ai}</span>
            <p className="modules-grid-tagline">{mod.tagline}</p>
          </Link>
        ))}
      </div>
      {showViewAll && (
        <div className="text-center">
          <Link to="/features" className="thm-btn agency-btn" style={{ display: "inline-block" }}>
            <span className="text">View All Modules</span>
          </Link>
        </div>
      )}
    </>
  );
};

export default ModulesGrid;
